import Container from "../../components/FormContainer/FormContainer.js";
import Section from "../../components/FormSection/FormSection.js";
import Row from "../../components/RowField/RowField.js";
import schoolMessengerLogo from "../../assets/images/schoolMessengerLogo.png";
import edsbyLogo from "../../assets/images/edsbyLogo.png";

function Communication({ title, children, imgSrc, imgAlt }) {
    return (
        < Section title={title} >
            <Row>
                <div style={{ width: "50%", flexGrow: 1 }}>
                    {children}

                </div>
                <img src={imgSrc} alt={imgAlt} style={{ borderRadius: "10px", maxHeight: "250px", aspectRatio: "1" }} />
            </Row>
        </Section >
    )
}

export default function Form() {
    return (
        <Container>
            <Communication title={"SchoolMessenger"}
                imgSrc={schoolMessengerLogo}
                imgAlt={"School Messenger Logo"}
            >
                An automated notification service which quickly delivers attendance calls, transportation calls, announcements and school or division-wide messages to students, parents, staff and school groups.
                <br /><br />Messages from SchoolMessenger will be directed to:
                <br />
                <ul>
                    <li>
                        <b>home phone number that you entered in Section 1: Student/Enrolment Information,</b>
                    </li>
                    <li>
                        <b>and/or contact numbers entered in Section 3. Student Contacts for student contacts with 1st or 2nd contact priority.</b>
                    </li>
                </ul>
            </Communication>
            <hr></hr>
            <Communication title={"Edsby"}
                imgSrc={edsbyLogo}
                imgAlt={"Edsby Logo"}>
                <p>
                    Will provide a way for parents and guardians to receive school updates, calendar events, view student progress and much more. It will help simplify
                    communication among and between teachers, students, and parents. For each of your children - even if they go to different schools within GSSD - you'll see your child(s) classes, teachers, and school information.
                </p>
            </Communication>
            <hr></hr>
            <Section>
                <b><i>Parent/guardian email addresses are required to create the account.</i></b>
                <b><span style={{ color: "red", fontWeight: "bold" }}> * </span><i>Please provide the email address on the next page.</i></b>
            </Section>
        </Container>
    )
}